import { useRef, useState } from 'react'
import Accordion from '../components/Accordion/Accordion'
import Icon from '../components/Icon/Icon'
import { breakpointSmall } from '../types'
import { useLanguageContext } from '../contexts/LanguageContext'
import Jokes from '../components/Jokes/Jokes'
import SEO from '../components/SEO/SEO'
import useWindowSize from '../hooks/useWindowSize'
import { useOutsideClick } from '../hooks/useOutsideClick'

export default function JokesPage({ type }: { type: string }) {
  const { t, language } = useLanguageContext()
  const { windowWidth } = useWindowSize()

  const [openAccordion, setOpenAccordion] = useState(false)

  const clickOutsideRef = useRef<HTMLDivElement>(null)

  const closeAccordion = () => {
    if (openAccordion) {
      setOpenAccordion(false)
    }
  }

  useOutsideClick({
    ref: clickOutsideRef,
    onOutsideClick: closeAccordion,
  })

  return (
    <>
      <SEO
        title={`${t('Jokes')} | ${t('TheComediansCompanion')}`}
        description={t('AJokeGeneratorForTheComicallyInclined')}
        canonicalUrl="https://jokes.jenniina.fi"
        ogTitle={`${t('Jokes')} | jokes.jenniina.fi`}
      />
      <div
        className={`${type} ${language}`}
        style={
          windowWidth < breakpointSmall
            ? { marginTop: '7em' }
            : { marginTop: '5em' }
        }
      >
        <div className="flex column accordion-wrap" ref={clickOutsideRef}>
          <Accordion
            text={
              <>
                <Icon
                  viewBox="2 2 20 20"
                  className={`info-icon ${openAccordion ? 'gray' : ''}`}
                  lib="ri"
                  name="RiQuestionLine"
                  aria-hidden="true"
                />
                <span className="scr">{t('Info')}</span>
              </>
            }
            className="info"
            wrapperClass="medium info-wrap"
            hideBrackets
            isOpen={openAccordion}
            setIsFormOpen={() => setOpenAccordion((prev) => !prev)}
            tooltip={t('Info')}
            x="left"
            y="below"
          >
            <div className="flex column gap-1 left">
              <p>{t('TheJokesAppUsesTheFollowingAPIsToFetchJokes')}:</p>
              <ul className="ul mt0">
                <li>
                  <a href="https://jokeapi.dev">JokeAPI</a>
                </li>
                <li>
                  <a href="https://icanhazdadjoke.com/api">
                    icanhazdadjoke.com
                  </a>
                </li>
                <li>
                  <a href="https://api.chucknorris.io">chucknorris.io</a>
                </li>
                <li>
                  <a href="https://official-joke-api.appspot.com">
                    Official Joke API
                  </a>
                </li>
                <li>
                  jokes.jenniina.fi/api{' '}
                  <span>({t('FetchesJokesFromAMongoDBDatabase')})</span>
                </li>
              </ul>
              <p>
                {t('By')} <a href="https://jenniina.fi"> Jenniina </a>
              </p>
              <p>
                <a href="https://github.com/jenniina/jokes">GitHub</a>
              </p>
            </div>
          </Accordion>
        </div>
        <Jokes />
      </div>
    </>
  )
}
